import { render } from "./Slider.vue?vue&type=template&id=fbe05760"
const script = {}

import "./Slider.vue?vue&type=style&index=0&id=fbe05760&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__